import React from 'react'
import {
  Button,
  Row,
  Col
} from '@themesberg/react-bootstrap'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Preloader from '../../../../components/Preloader'
import useReorderSubCategories from '../useReorderCategories'
import PageBackButton from '../../../../components/PageBackButton'

export default () => {
  const {
    loading,
    state,
    onDragEnd,
    handleSave
  } = useReorderSubCategories()

  // Define your headers - add/remove as needed
  const headers = [
    'ID',
    'Name',
    'Status',
    'Category Type',
    'Game Limit'
    // Add more headers here as needed
    // 'Extra Column 1',
    // 'Extra Column 2',
    // etc.
  ]

  // Define how to extract data from each row - should match headers order
  const getRowData = (rowItem) => [
    rowItem.gameCategoryId,
    rowItem.name || "N/A",
    rowItem.is_active
      ? <span className='text-success'>Active</span>
      : <span className='text-danger'>Inactive</span>,
    rowItem.categoryType || "N/A",
    rowItem.gameLimit || "N/A"

  ]

  return (
    <>
      {loading
        ? <Preloader />
        : (
          <>
            <Row>
              <Col sm={8} className='backbtn mb-2'>
                <PageBackButton />
                <h3 className='mb-0'>Casino Categories Reorder</h3>
              </Col>

              <Col>
                <div className='text-right mb-3'>
                  <Button
                    variant='outline-success'
                    onClick={() => handleSave()}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>


            <div className='reorder-container name-large'>
              {/* Dynamic header generation */}
              <div className='reorder-heading'>
                {headers.map((header, index) => (
                  <p key={`header-${index}`} className='header-reorder'>
                    {header}
                  </p>
                ))}
              </div>

              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId='list'>
                  {provided => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {state.count > 0 &&
                        state?.rows?.map((rowItem, idx) => {
                          const rowData = getRowData(rowItem);

                          return (
                            <Draggable draggableId={`id-${idx}`} key={idx} index={idx}>
                              {provided => (
                                <div
                                  className='reorder-content'
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {/* Dynamic cell generation */}
                                  {rowData.map((cellData, cellIndex) => (
                                    <p
                                      key={`cell-${idx}-${cellIndex}`}
                                      title={typeof cellData === 'string' ? cellData : ''}
                                    >
                                      {cellData}
                                    </p>
                                  ))}
                                </div>
                              )}
                            </Draggable>
                          )
                        })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              {state.count === 0
                ? <p className='text-danger text-center'>No data found</p>
                : null}
            </div>
          </>
        )}
    </>
  )
}